// react
import { useState } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// dialogs
import { DialogActions } from '../DialogActions/DialogActions';

// forms
import { FormEditCategory } from '../../forms/FormEditCategory/FormEditCategory';

// props
export interface DialogEditCategoryProps {
	isOpen: boolean;
	onClose: () => void;
	onSuccess?: () => void;
}

export const DialogEditCategory = ({ isOpen, onClose, onSuccess }: DialogEditCategoryProps) => {
	// hooks
	const { t } = useTranslation();

	// state
	const [isLoading, setIsLoading] = useState(false);

	return (
		<DialogActions
			actions={[
				{
					children: t('cancel'),
					onClick: onClose,
				},
				{
					children: t('saveCategory'),
					loading: isLoading,
					form: 'form-edit-category',
					type: 'submit',
					variant: 'contained',
				},
			]}
			hasClose={true}
			isOpen={isOpen}
			maxWidth={700}
			onClose={onClose}
			title={{
				children: t('editCategory'),
				variant: 'h3',
			}}>
			<FormEditCategory onClose={onClose} onSuccess={onSuccess} setIsLoading={setIsLoading} />
		</DialogActions>
	);
};
